import { CloseOutlined, InfoCircleOutlined, SettingOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Modal,
  Button,
  Row,
  Form,
  Checkbox,
  notification,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import styles from './diagnosis/Diagnosis.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { Checks, Settinglable } from '../../models/setting'
import { Tenant } from '../../models/tenant'
import { selectSettings, saveSettingLabel, getSettingDetail } from '../user/setting/settingSlice'
import { selectTenant } from '../user/setting/settingSlice'
import _ from 'lodash'

export const CopySettingModal = (props: {
  visible?: any
  flag?: number
  onCancel: () => void
  onOk: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()
  
  const settings = useSelector(selectSettings)
  const tenant = useSelector(selectTenant) as Tenant
  
  const [loading, setLoading] = useState(false)

  // 回显当前设置
  useEffect(() => {
    if (props.visible) {
      const settingKey = props?.flag == 1 ? Checks.FZCTJG : Checks.FZCFJG
      const currentValue = settings?.[settingKey] || ['1', '2', '3']
      form.setFieldsValue({
        price: currentValue,
      })
    }
  }, [props.visible, props?.flag, settings, form])
  
  // 保存设置
  const handleSave = () => {
    form.validateFields().then((values) => {
      const settingKey = props?.flag == 1 ? Checks.FZCTJG : Checks.FZCFJG
      const settingValue = values.price || []
      
      if (settingValue.length === 0) {
        notification.warning({ message: '请至少选择一个价格选项', duration: 3 })
        return
      }
      
      setLoading(true)
      
      const pattern = /^[0-9]*$/
      const mergedValues: any = {
        [settingKey]: settingValue,
      }
      
      const t = _.chain(mergedValues)
        .omitBy((_, k) => pattern.test(k))
        .value()
      
      const f = _.chain(mergedValues)
        .pickBy((_, k) => pattern.test(k))
        .mapValues(
          (v: any, k: string) =>
          ({
            type: k,
            value: v?.toString(),
          } as Settinglable)
        )
        .values()
        .value() as Settinglable[]
      
      dispatch(
        saveSettingLabel({
          tenant: {
            ...tenant,
            ...t,
          } as Tenant,
          functionList: f,
        })
      )
        .then(unwrapResult)
        .then(() => {
          notification.success({ 
            message: '保存成功,部分配置需要重新登陆后生效', 
            duration: 3 
          })
          dispatch(getSettingDetail())
          props.onOk()
        })
        .catch(() => {
          notification.error({ message: '保存失败', duration: 3 })
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return (
    <Modal
        width={650}
        visible={props.visible}
        title={'复制' + (props?.flag == 1 ? '套餐' : '处方') + '价格设置'}
        destroyOnClose
        className={styles.modal}
        onOk={handleSave}
        onCancel={props.onCancel}
        confirmLoading={loading}
      >
      <div style={{marginBottom: 20}}>
        <Form form={form}>
          {props.flag == 1 ? (
            <Form.Item name="price" label="价格选择">
              <Checkbox.Group>
                <Checkbox value='1' style={{width:'160px'}}>使用目录价格</Checkbox>
                <Checkbox value='2' style={{width:'160px'}}>使用套餐价格</Checkbox>
                <Checkbox value='3' style={{width:'160px'}}>使用库存价格</Checkbox>
              </Checkbox.Group>
            </Form.Item>
          ) : (
            <Form.Item name="price" label="价格选择">
              <Checkbox.Group>
                <Checkbox value='1' style={{width:'160px'}}>使用目录价格</Checkbox>
                <Checkbox value='2' style={{width:'160px'}}>使用处方价格</Checkbox>
                <Checkbox value='3' style={{width:'160px'}}>使用库存价格</Checkbox>
              </Checkbox.Group>
            </Form.Item>
          )}
        </Form>
      </div>
      <div style={{ color: '#666666', fontSize: '14px' }}>注：1、如果选择了使用库存价格，诊疗项目则使用目录价格</div>
      <div style={{ color: '#666666', fontSize: '14px', marginLeft: 28 }}>
        2、如选择多个则开方时再根据情况选择，如选择一个则开方时无需再次选择
      </div>
    </Modal>
  )
}
